module.exports = __webpack_public_path__ + "img/top3.0e9ea5c1.png";